import * as Sentry from "@sentry/capacitor";

let storeNumber = 0;

/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
    setStoreNumber(sn: number) {
        storeNumber = sn;
    },

    warn(msg: string, attributes: Record<string, unknown> = {}) {
        if (storeNumber) {
            attributes["storeNumber"] = storeNumber;
        }

        if (import.meta.env.DEV) {
            console.warn(msg, attributes);
        }
        Sentry.logger.warn(msg, attributes);
    },

    error(msg: string, attributes: Record<string, unknown> = {}) {
        if (storeNumber) {
            attributes["storeNumber"] = storeNumber;
        }

        if (import.meta.env.DEV) {
            console.error(msg, attributes);
        }
        Sentry.logger.error(msg, attributes);
    },

    debug(msg: string, attributes: Record<string, unknown> = {}) {
        if (storeNumber) {
            attributes["storeNumber"] = storeNumber;
        }

        if (import.meta.env.DEV) {
            console.debug(msg, attributes);
        }
        Sentry.logger.debug(msg, attributes);
    },

    info(msg: string, attributes: Record<string, unknown> = {}) {
        if (storeNumber) {
            attributes["storeNumber"] = storeNumber;
        }

        if (import.meta.env.DEV) {
            console.info(msg);
        }
        Sentry.logger.info(msg, attributes);
    },

    trace(msg: string, attributes: Record<string, unknown> = {}) {
        if (storeNumber) {
            attributes["storeNumber"] = storeNumber;
        }

        if (import.meta.env.DEV) {
            console.trace(msg, attributes);
        }
        Sentry.logger.trace(msg, attributes);
    },
};
